import { ReduxDispatch } from "./reducerTypes"
import { useDispatch } from "react-redux";

export function useReduxDispatch(): ReduxDispatch {
  return useDispatch<ReduxDispatch>();
}
